import React from 'react'
import "./footer.css"

const Footer = () => {
  return (
    <div className='footer'>
      <div className="flist">
        <ul className="flists">
          <li className="flistItem">Countries</li>
          <li className="flistItem">Regions</li>
          <li className="flistItem">Cities</li>
          <li className="flistItem">Districs</li>
          <li className="flistItem">Airpots</li>
          <li className="flistItem">Hotels</li>
          <li className="flistItem">Places of interest</li>
        </ul>
        

        <ul className="flists">
          <li className="flistItem">Home</li>
          <li className="flistItem">Apartments</li>
          <li className="flistItem">Resorts</li>
          <li className="flistItem">Villas</li>
          <li className="flistItem">Hotels</li>
          <li className="flistItem">B & Bs</li>
          <li className="flistItem">Guest house</li>
        </ul>

        <ul className="flists">
          <li className="flistItem">Unique Place to Stay</li>
          <li className="flistItem">All Destinations</li>
          <li className="flistItem">Discover</li>
          <li className="flistItem">Reviews</li>
          <li className="flistItem">Unpacked: Travels articles</li>
          <li className="flistItem">Travel Communation</li>
          <li className="flistItem">Seasonls and holidays Deals</li>
        </ul>

        <ul className="flists">
          <li className="flistItem">Car rental</li>
          <li className="flistItem">Flights finder</li>
          <li className="flistItem">Restaurent reservations</li>
          <li className="flistItem">Booking.com for Travel agents</li>
        </ul>

        <ul className="flists">
          <li className="flistItem">Coronavirus: covid19 facts</li>
          <li className="flistItem">About Booking.com</li>
          <li className="flistItem">Custom service help</li>
          <li className="flistItem">Partners helps</li>
          <li className="flistItem">Carress</li>
          <li className="flistItem">Sustainabillity</li>
          <li className="flistItem">Press center</li>
          <li className="flistItem">Safesty Resourtes centers</li>
          <li className="flistItem">Investors Relations</li>
          <li className="flistItem">Term and conditions</li>
          <li className="flistItem">Partners disputr</li>
          <li className="flistItem">How we work</li>
          <li className="flistItem">Privacy and cookiesattement</li>
          <li className="flistItem">MSA statement</li>
          <li className="flistItem">Corporate statement</li>
        </ul>
      </div>
      <h2 className="extranet">Extranet login</h2>
      <div className="fText">Copyright@2022Emarnbooking.com|| All right reserved</div>
      <p className="extranet">Booking.com is part of Booking Holdings Inc., the world leader in online travel and related services.</p>
    </div>
  )
}

export default Footer
